import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryLaunchSessionTeamsSelector from 'redux/selectors/my_library/my_library_launch_session_teams_selector'
import { localize } from 'helpers/translator'
import { updateMicrosoftTeams, initializeMicrosoftTeams, setValidityState } from 'helpers/social/microsoftTeamsActions'
import sessionTypes from 'helpers/enums/sessionTypes'

import Npp from 'components/npp/npp'
import { TextInput } from 'components/dpc_input'
import { CancelButton } from 'components/button'
import SecondaryTitle from 'components/title_secondary/title_secondary'

import styles from './my_library_launch_session_teams.scss'

const studentIcon = <svg width="18" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M17.082 15.046s.189-4.532.189-6.176c0-1.643-2.656-1.667-2.656-1.667s-2.13-.174-2.848.344c-.717.518-3.555 3.683-3.555 3.683l-.232.2-2.542-.067 1.46-1.37-3.762-5.512L0 8.381l2.422 3.833s-.483.804-.077 1.226c.405.422.96.545.96.545l6.378-.128 1.893-2.008-.583 3.197h6.09zM13 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fill="#00a8ff" fillRule="evenodd"/></svg>

class LaunchSessionTeams extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			title: props.payload.tabName,
		}
		this.handleClose = this.handleClose.bind(this)
	}


	componentDidMount() {
		initializeMicrosoftTeams(this.props.payload.tabUrl, this.state.title)
	}

	handleClose() {
		this.props.actions.closeLaunchSessionTeams()
	}

	componentWillUnmount() {
		setValidityState(false)
	}

	componentDidUpdate(prevState) {
		if (prevState.title !== this.state.title) {
			updateMicrosoftTeams(this.state.title)
		}
	}

	onChange = event => {
		this.setState({
			title: event.target.value,
		})
	}

	getTitle = () => localize(
		this.props.sessionType === sessionTypes.LIVE_SESSION ?
			'lessons_list_npp_action_live_participation'
			: 'lessons_list_npp_action_student_paced'
	)

	render() {
		const lessonData = this.props.lessonData
		return (
			<div styleName='wrapper'>
				<div styleName='npp-container'>
					<Npp
						lessonImage={lessonData.thumb}
						title={lessonData.name}
						author={lessonData.author.data.name}
						date={lessonData.modified_formatted}
						size={lessonData.size}
						isNew={lessonData.isNew}
						isHighlighted={lessonData.highlight}
						authorImage={lessonData.author.data.thumb}
						tooltip={false}
						price_bar={false} />
				</div>
				<div styleName='container-right'>
					<SecondaryTitle icon={studentIcon}>{this.getTitle()}</SecondaryTitle>
					<div styleName='input'>
						<TextInput type='text' onChange={this.onChange} value={this.state.title} />
					</div>
					<div styleName='cancel'>
						<CancelButton onClick={this.handleClose}>Cancel</CancelButton>
					</div>
				</div>
			</div>
		)
	}
}

LaunchSessionTeams.propTypes = {
	actions: PropTypes.shape({
		closeLaunchSessionTeams: PropTypes.func,
	}),
	presentationUid: PropTypes.string.isRequired,
	payload: PropTypes.shape({
		pincode: PropTypes.string,
		tabName: PropTypes.string,
		tabUrl: PropTypes.string,
		lmsName: PropTypes.string,
	}),
	sessionType: PropTypes.oneOf(Object.values(sessionTypes)),
	lessonData: PropTypes.shape({
		thumb: PropTypes.string,
		name: PropTypes.string,
		author: PropTypes.object,
		modified_formatted: PropTypes.string,
		size: PropTypes.number,
		isNew: PropTypes.bool,
		highlight: PropTypes.bool,
	}),
}

LaunchSessionTeams.defaultProps = {
	actions: {
		closeLaunchSessionTeams: () => {},
	},
	payload: PropTypes.shape({
		pincode: '',
		tabName: '',
		tabUrl: '',
		lmsName: '',
	}),
	sessionType: sessionTypes.HOMEWORK,
	lessonData: PropTypes.shape({
		thumb: '',
		name: '',
		author: {data: {name: '', thumb: ''}},
		modified_formatted: '',
		size: 0,
		isNew: false,
		highlight: false,
	}),
}

function mapStateToProps(state, ownProps) {
	return myLibraryLaunchSessionTeamsSelector(state, ownProps.presentationUid)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeLaunchSessionTeams: myLibraryActions.closeLaunchSessionTeams,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(LaunchSessionTeams, styles, {allowMultiple: true}))
export { LaunchSessionTeams }
